/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicRetailersCampaignsBECampaignImage {
    ID?: number;
    /**
     * 1 = Html, 2 = Image, 3 = Video, 4 = Gif
     */
    Type?: Open360BusinessLogicRetailersCampaignsBECampaignImage.TypeEnum;
}
export namespace Open360BusinessLogicRetailersCampaignsBECampaignImage {
    export type TypeEnum = 1 | 2 | 3 | 4;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum,
        NUMBER_3: 3 as TypeEnum,
        NUMBER_4: 4 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersCampaignsBECampaignImage.ts